import { CustomAppLayout } from '../../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Alert, Box, Button, Form, FormField, Input, Link, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiCreditCardCheck, mdiCreditCardLockOutline, mdiCreditCardRemove } from '@mdi/js';
import { Icon } from '@mdi/react';
import Favorites from '../../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../../hooks/fetchWithWatch';
import { buildBreadcrumbItems, formatCurrency, getCookie, getUrlVersion, setLoading } from '../../../../../commons/functions';



export const MembersAccountWebPayPage = () => {
    const { menu } = useGlobalState();
    const [ammount, setAmmount] = useState<number>(0);
    const [ammountFormatted, setAmmountFormatted] = useState<string>(formatCurrency(0, "CLP"));
    const [inputType, setInputType] = useState<"text" | "number" | "password" | "email" | "url">("text");
    const [idMovementTBK, setIdMovementTBK] = useState<number>(0);
    const [movementTBK, setMovementTBK] = useState<any>();
    const [balance, setBalance] = useState<number>(0);
    const [user, setUser] = useState<any>();


    const handleGetBalance = async () => {
        try {

            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/login/data',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({})
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();

            if (data.code === 0) {
                setBalance(data.balance);
                setUser(data);
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);

        }
    };
    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const id = params.get("id");

            if (id) {
                setIdMovementTBK(id ? parseInt(id) : 0);
                handleGetMovementTBK(id ? parseInt(id) : 0);
            }
        };

        window.addEventListener("hashchange", handleHashChange);
        // also trigger once on mount
        handleHashChange();
        handleGetBalance();
        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);

    const handleGetMovementTBK = async (id: number) => {
        try {

            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/movements/webpay/get',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    idMovementTBK: id
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();

            if (data.code === 0) {

                setMovementTBK(data.webpay);
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);

        }
    };
    const handleWebPay = async () => {
        try {

            setLoading(true);
            const baseUrl = btoa(`${window.location.protocol}//${window.location.host}`);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/movements/webpay/initiate',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    ammount: ammount,
                    host: baseUrl
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();

            if (data.code === 0) {
                const form = document.createElement("form");
                form.method = "POST";
                form.action = data.webpay.url;

                // Add hidden input
                const input = document.createElement("input");
                input.type = "hidden";
                input.name = "token_ws";
                input.value = data.webpay.token;
                form.appendChild(input);
                // Append to body and submit
                document.body.appendChild(form);
                form.submit();
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);

        }
    };

    useEffect(() => {

    }, []);
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    {movementTBK && (
                        <Alert
                            type={movementTBK.responseCode === 0 ? "success" : "warning"}
                            action={<Button onClick={() => {
                                window.location.hash = "#members/accounts/payments/webpay"
                                setIdMovementTBK(0);
                                setMovementTBK(undefined);
                            }}>Cerrar</Button>}
                            header={
                                <>
                                    Resultado de la transacción{" "}
                                    {movementTBK.responseCode === 0 ? (
                                        <Icon path={mdiCreditCardCheck} size={1} />
                                    ) : (
                                        <Icon path={mdiCreditCardRemove} size={1} />
                                    )}
                                </>
                            }
                        >
                            {movementTBK.responseCode === 0 && (
                                <>
                                    <span>Su abono de <strong>{movementTBK.amount} CLP</strong> ha sido procesado correctamente. Su nuevo saldo en cuenta club es de <strong>{movementTBK.balance} CLP</strong>.</span>
                                    <br />
                                    <span>Tarjeta <strong>**** **** **** {movementTBK.cardNumber} {movementTBK.paymentType}</strong>, código de autorización: <strong>{movementTBK.authorizationCode}</strong>, comprobante de ingreso <strong>#{movementTBK.idMovement}</strong></span>
                                    <br />
                                    <br />ID de transacción WebPay: <strong>{movementTBK.buyOrder}</strong>

                                </>
                            )}
                            {!!movementTBK.responseCode && movementTBK.responseCode !== 0 && (
                                <>
                                    <span>Su abono de <strong>{movementTBK.amount} CLP</strong> no ha podido ser procesado correctamente.</span>
                                    <br />
                                    <span>Código de error: <strong>{movementTBK.responseCode}</strong>, mensaje: <strong>{movementTBK.responseCodeReason}</strong></span>

                                    <br />ID de transacción WebPay: <strong>{movementTBK.buyOrder}</strong>

                                </>
                            )}

                        </Alert>
                    )}
                    {!movementTBK && (

                        <SpaceBetween size="s">
                            <Header
                                variant="h2"
                                actions={<Favorites />}
                                description={
                                    <>
                                        Los abonos realizados por WebPay son exclusivamente para <strong>Abonos a su Cuenta Club</strong>.
                                        En caso de que usted quiera realizar un pago por cuota de incorporación debe coordinarlo
                                        directamente con la <strong>Oficina de Administración</strong>.
                                        <br /><br />
                                        Su saldo actual de su cuenta socios es de:

                                        {/* Check if user exists first */}
                                        <strong>{!user ? " Cargando..." : (
                                            <>
                                                {/* Corrected logic: 
                                                                1. If balance === 0, show "Sin deuda"
                                                                2. If balance !== 0, show the formatted currency
                                                            */}
                                                {user.balance === 0
                                                    ? " Sin deuda"
                                                    : ` ${user.balance.toLocaleString('es-CL', { style: 'currency', currency: 'CLP' })}`
                                                }

                                                {/* Only show the "Abonar el total" link if the balance is negative (debt) */}
                                                {user.balance < 0 && (
                                                    <>
                                                        {" "}
                                                        <Link onClick={() => {
                                                            setAmmount(-user.balance);
                                                            setAmmountFormatted(formatCurrency(-user.balance, "CLP"));
                                                        }}>
                                                            Abonar el total
                                                        </Link>
                                                    </>
                                                )}
                                            </>
                                        )}</strong>
                                    </>
                                }
                            >
                                Abono vía Tarjeta <Icon path={mdiCreditCardLockOutline} size={1} />
                            </Header>

                            <Form>
                                <SpaceBetween size="s">
                                    <div style={{ width: 300 }}>
                                        <FormField
                                            constraintText="El monto mínimo para abonar es de 30.000 CLP."
                                            label="Monto a abonar (CLP)" description="Ingrese el monto que desea abonar a su cuenta club.">
                                            <Input type={inputType || "text"} placeholder="Ingrese el monto a abonar" autoFocus value={ammountFormatted}
                                                onBlur={() => {
                                                    setInputType("text");
                                                    setAmmountFormatted(formatCurrency(ammount, "CLP"))
                                                }}
                                                onFocus={() => {
                                                    setInputType("number");
                                                    setAmmountFormatted(ammount.toString())
                                                }}
                                                onChange={(e) => {
                                                    setAmmount(Number(e.detail.value))
                                                    setAmmountFormatted(Number(e.detail.value).toString())

                                                }} />
                                        </FormField>
                                    </div>
                                    <div style={{ width: 300 }}>
                                        <Box textAlign='right'><Button variant="primary" disabled={ammount < 30000}
                                            onClick={handleWebPay}
                                        >Pagar con WebPay</Button></Box>
                                    </div>
                                </SpaceBetween>
                            </Form>
                        </SpaceBetween>


                    )}
                </SpaceBetween >
            }
        />
    );
};
